<div [class]="'animate-pulse ' + class">
    <div [class]="'bg-gray-200 rounded ' + dimensions"></div>
  </div>